// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const munchlax: PokeData = {
  "id": 446,
  "name": "munchlax",
  "height": 6,
  "weight": 1050,
  "base_experience": 78,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "double-edge",
    "bite",
    "screech",
    "defense-curl",
    "metronome",
    "lick",
    "amnesia",
    "rest",
    "flail",
    "belly-drum",
    "rollout",
    "stockpile",
    "swallow",
    "recycle",
    "snatch",
    "odor-sleuth",
    "covet",
    "natural-gift",
    "fling",
    "last-resort",
    "giga-impact",
    "zen-headbutt",
    "chip-away",
    "bulldoze",
    "high-horsepower"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "bite",
    "lick",
    "snatch",
    "zen-headbutt",
    "supersonic",
    "leer",
    "purification",
    "splash",
    "scary-face",
    "growl",
    "headbutt"
  ],
  "evolution_chain": {
    "id": 72,
    "item": {
      "name": "full-incense"
    },
    "species": [
      {
        "name": "munchlax",
        "order": 174,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "snorlax",
        "order": 175,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 446,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 98.75,
    "speed": 5,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
